import React, { useState } from 'react';

import { Button, Input, Modal, message, Form, notification } from 'antd';
import { UploadFile, FormErrorParser } from '@partsbadger/library';
import { INDAFormPayload } from 'types/types';
import UserStore from 'stores/UserStore';

import { FormItemProps } from '@ant-design/compatible/es/form';

import ErrorRender from 'components/shared/ErrorRender';

interface INDAForm {
    record?: INDAFormPayload;
    onChange: (isChange: boolean) => void;
}

function AddEditNDAForm({ record, onChange }: INDAForm) {
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(false);

    const [form] = Form.useForm();

    const handleSubmit = () => {
        form.validateFields()
            .then(async values => {
                const uploadedFiles = (values.files || []).filter((f: any) => f.status === 'done' && f.response?.id);
                if (uploadedFiles.length === 0) {
                    notification.error({
                        message: 'Invalid file',
                        description: 'Please upload a valid PDF file before submitting.',
                    });
                    return;
                }
                setLoading(true);
                const payload = {
                    name: UserStore.contact?.fullname,
                    company_name: UserStore.contact?.account,
                    email: UserStore.contact?.email,
                    files: uploadedFiles.map((f: any) => f.response.id),
                };
                if (record) {
                    return await UserStore.editNDAForm(payload, record.id)
                        .then(() => {
                            message.success(`Edited Successfully!!!`),
                                onChange(true),
                                setLoading(false),
                                setVisible(false);
                        })
                        .catch(error => {
                            setLoading(false);

                            notification.error({
                                message: 'Error',
                                description: <ErrorRender error={error} />,
                            });
                        });
                }
                await UserStore.addNDAForm(payload)
                    .then(data => {
                        message.success(`Created Successfully!!!`),
                            onChange(true),
                            setLoading(false),
                            setVisible(false);
                    })
                    .catch(error => {
                        message.error(`Error: ${error}`), setLoading(false);
                    });
            })
            .catch(errorInfo => {
                setLoading(false);
                notification.error({
                    key: 'form-errors',
                    duration: 8,
                    message: 'Please input all required fields',
                    description: <FormErrorParser isAntd4 errors={errorInfo.errorFields} />,
                    placement: 'top',
                    maxCount: 1,
                });
            });
    };

    const formItemLayout: FormItemProps = {
        labelCol: {
            // xs: { span: 24 },
            // sm: { span: 24 },
            md: { span: 24 },
        },
        wrapperCol: {
            // xs: { span: 24 },
            // sm: { span: 16 },
            md: { span: 24 },
        },
        labelAlign: 'left',
    };

    return (
        <>
            <>
                {record ? (
                    <Button
                        style={{ color: '#405767' }}
                        onClick={() => setVisible(!visible)}
                        loading={loading}
                        type="link"
                        size="small"
                    >
                        Edit
                    </Button>
                ) : (
                    <div style={{ textAlign: 'center', margin: 'auto' }}>
                        <Button onClick={() => setVisible(!visible)} loading={loading} type="primary" size="large">
                            Add NDA Form
                        </Button>
                    </div>
                )}
            </>

            <Modal
                open={visible}
                title={record ? 'Edit NDA Form' : 'Add NDA Form'}
                onOk={() => setVisible(false)}
                onCancel={() => setVisible(false)}
                footer={null}
            >
                <Form form={form} className={'checkout'}>
                    <Form.Item
                        label="File"
                        {...formItemLayout}
                        name="files"
                        rules={[{ required: true, message: 'Please input a file.' }]}
                        initialValue={record?.files.map(r => {
                            return {
                                uid: r.id,
                                name: r.filename,
                                status: 'done',
                                response: {
                                    id: r.id,
                                },
                                url: r.file,
                            };
                        })}
                    >
                        <UploadFile accept={['pdf']} />
                    </Form.Item>

                    <div className="flex justify-between mt-5">
                        <Button
                            key="back"
                            onClick={() => setVisible(false)}
                            size="large"
                            style={{ color: '#D92923', borderColor: '#D92923' }}
                        >
                            Close
                        </Button>

                        <Button
                            key="submit"
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            onClick={handleSubmit}
                            size="large"
                        >
                            Submit
                        </Button>
                    </div>
                </Form>
            </Modal>
        </>
    );
}

export default AddEditNDAForm;
